import React from 'react';
import propTypes from 'prop-types';
export const GenderIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.9999 14.5028C37.7948 14.5028 39.2499 13.0471 39.2499 11.2514C39.2499 9.4557 37.7948 8 35.9999 8C34.205 8 32.7499 9.4557 32.7499 11.2514C32.7499 13.0471 34.205 14.5028 35.9999 14.5028ZM29.3847 26.0764L32.0763 19.6097V21.8354V29.6806V38.6808C32.0763 39.4065 32.6815 40.0002 33.4211 40.0002C34.1608 40.0002 34.766 39.4065 34.766 38.6808V29.6806H37.3102V38.6808C37.3102 39.4065 37.9154 40.0002 38.655 40.0002C39.3947 40.0002 39.9999 39.4065 39.9999 38.6808V29.6806V21.8354V20.057L42.6241 26.0977C42.9542 26.8575 43.8378 27.2059 44.5976 26.8758C45.3574 26.5457 45.7058 25.6621 45.3757 24.9023L42.1273 17.4249C41.7514 16.5597 40.898 16 39.9548 16H35.1769H33.1198H31.909C30.9524 16 30.0898 16.5754 29.7222 17.4585L26.6151 24.9236C26.2967 25.6884 26.6587 26.5665 27.4235 26.8848C28.1883 27.2032 29.0664 26.8412 29.3847 26.0764ZM5.33853 25.0948L8.00004 19.8342V24.3122H7.99997L5.44179 30.8923C5.1458 31.6537 5.70744 32.4746 6.52431 32.4746H8.00004V38.6142C8.00004 39.3975 8.61701 40.0384 9.37107 40.0384C10.1251 40.0384 10.7421 39.3975 10.7421 38.6142V32.4746H13.2555V38.6142C13.2555 39.3975 13.8725 40.0384 14.6266 40.0384C15.3806 40.0384 15.9976 39.3975 15.9976 38.6142V32.4746H17.7534C18.5883 32.4746 19.1505 31.6201 18.82 30.8534L16 24.3122H15.9976V19.8292L18.6616 25.0948C19.0356 25.8341 19.938 26.1301 20.6772 25.7561C21.4164 25.3822 21.7125 24.4797 21.3385 23.7405L18.1609 17.4597C17.7078 16.5642 16.7896 15.9997 15.7861 15.9997H11.3365H9.2369H8.2141C7.21055 15.9997 6.29233 16.5642 5.83929 17.4597L2.66163 23.7405C2.28764 24.4797 2.58371 25.3822 3.32292 25.7561C4.06212 26.1301 4.96454 25.8341 5.33853 25.0948ZM12 14.5028C13.7949 14.5028 15.25 13.0471 15.25 11.2514C15.25 9.4557 13.7949 8 12 8C10.2051 8 8.75 9.4557 8.75 11.2514C8.75 13.0471 10.2051 14.5028 12 14.5028Z"
        fill={color}
      />
    </svg>
  );
};
GenderIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
GenderIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
